import React from "react";
import { menuIcon } from "./menuIcons";

/** One sidebar entry (a level-1 menu from the backend) with its icon. */
const MenuItem = ({ item, onClick, isActive }) => {
  if (!item) {
    return null;
  }

  return (
    <li className="nav-item">
      <a
        className={`nav-link ${isActive ? "" : "collapsed"}`}
        href="#"
        aria-current={isActive ? "page" : undefined}
        onClick={(event) => {
          event.preventDefault(); // navigation is done by onClick
          onClick();
        }}
      >
        <i className={`bi ${menuIcon(item)}`} aria-hidden="true" />
        <span>{item}</span>
      </a>
    </li>
  );
};

export default MenuItem;
